import { Box } from '@chakra-ui/react';
import Header from './Header';
import SuitesList from './SuitesList';

interface Props {
  location: {
    address: string;
    maxSuites: number;
    availableSuites: number[];
  };
}

function Suites({ location }: Props) {
  return (
    <Box p={8}>
      <Header />
      <SuitesList location={location} />
    </Box>
  );
}
export default Suites;
